import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './Card';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Compré esta guía hace exactamente 2 meses y hoy me estoy preparando para la temporada en las Islas Baleares. Tener un paso a paso claro hizo una diferencia enorme.',
  author: 'Martín G.'
}, {
  quote: 'Vivía en Zona Sur y trabajaba en Caballito, pasaba horas viajando y la rutina me consumía. Hoy vivo en la Polinesia y tengo dos meses de vacaciones al año. Nunca imaginé un cambio así.',
  author: 'Lucas M.'
}, {
  quote: 'Siempre pensé que trabajar en yates era imposible para alguien como yo. Dos semanas después, ya estaba dando mis primeros pasos reales.',
  author: 'Sebastián R.'
}];
export function Testimonials() {
  return <section className="py-16 bg-secondary/20" data-id="element-175">
      <div className="px-5" data-id="element-176">
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-177">
          <h2 className="text-3xl font-bold text-white font-heading mb-3 leading-tight" data-id="element-178">
            Lo que dicen otros
            <br data-id="element-179" />
            profesionales
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto rounded-full" data-id="element-180"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-181">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-182">
              <Card className="bg-background border-border/50" data-id="element-183">
                <CardContent className="p-5" data-id="element-184">
                  <div className="flex gap-0.5 mb-3" data-id="element-185">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-primary text-primary" data-id="element-186" />)}
                  </div>
                  <p className="text-base text-white/80 italic mb-4 leading-relaxed" data-id="element-187">
                    "{testimonial.quote}"
                  </p>
                  <div className="flex items-center gap-3" data-id="element-188">
                    <div className="w-9 h-9 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-sm" data-id="element-189">
                      {testimonial.author.charAt(0)}
                    </div>
                    <p className="text-white font-bold text-sm" data-id="element-190">
                      {testimonial.author}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}